// 轨迹 / 人物配置解析相关的纯函数工具
import servoList from '../servoList.json'

// 检查是否是嵌套的轨迹结构（包含人物）
export function isNestedTrajectory(trajectoryGroup) {
  // 如果对象有 servoVersions 和 ids 属性，说明是旧格式（直接是轨迹配置）
  // 否则是新格式（包含多个人物配置，通过检查第一个值是否有 personName 字段）
  if (trajectoryGroup.servoVersions && trajectoryGroup.ids) {
    return false
  }
  // 检查第一个值是否有 personName 字段
  const firstKey = Object.keys(trajectoryGroup)[0]
  if (firstKey && trajectoryGroup[firstKey] && trajectoryGroup[firstKey].personName) {
    return true
  }
  return false
}

// 根据 personName 查找配置
export function findPersonConfigByPersonName(trajectoryGroup, personName) {
  if (!trajectoryGroup || !personName) return null
  for (const key in trajectoryGroup) {
    if (trajectoryGroup[key] && trajectoryGroup[key].personName === personName) {
      return trajectoryGroup[key]
    }
  }
  return null
}

// 根据 personName 查找对应的数字键（personId）
export function findPersonIdByPersonName(trajectoryGroup, personName) {
  if (!trajectoryGroup || !personName) return null
  for (const key in trajectoryGroup) {
    if (trajectoryGroup[key] && trajectoryGroup[key].personName === personName) {
      return key
    }
  }
  return null
}

// 根据 personId（数字键）查找配置
export function findPersonConfigByPersonId(trajectoryGroup, personId) {
  if (!trajectoryGroup || !personId) return null
  return trajectoryGroup[personId] || null
}

// 根据零位名称获取坐标
export function getOriginPosition(trajectoryConfig, originName = 'origin') {
  if (!trajectoryConfig) return { x: 0, y: 0 }

  // 如果是 'default'，使用向后兼容的 x, y
  if (originName === 'default') {
    return {
      x: Number((trajectoryConfig.x ?? 0).toFixed(1)),
      y: Number((trajectoryConfig.y ?? 0).toFixed(1))
    }
  }

  // 查找对应的零位
  const origin = trajectoryConfig[originName]
  if (origin && origin.x !== undefined && origin.y !== undefined) {
    return {
      x: Number((origin.x).toFixed(1)),
      y: Number((origin.y).toFixed(1))
    }
  }

  // 如果找不到，回退到向后兼容的 x, y
  return {
    x: Number((trajectoryConfig.x ?? 0).toFixed(1)),
    y: Number((trajectoryConfig.y ?? 0).toFixed(1))
  }
}

/** 舵机名称中的「左」「右」互换，用于嘴角镜像时解析目标侧真实舵机号 */
export function swapLeftRightInServoName(name) {
  if (!name || typeof name !== 'string') return name
  return name.split('').map(c => (c === '左' ? '右' : c === '右' ? '左' : c)).join('')
}

/** 左/右嘴角：按当前型号在 servoList 中解析双舵机 ID（名称含左/右+嘴角且成对；顺序 下→上） */
export function resolveMouthCornerServoIdsForDevice(trajectoryName, deviceVersion) {
  if (!trajectoryName || !deviceVersion || !servoList[deviceVersion]) return null
  const wantLeft = trajectoryName === '左嘴角'
  const wantRight = trajectoryName === '右嘴角'
  if (!wantLeft && !wantRight) return null
  const candidates = servoList[deviceVersion].filter(s => {
    const n = s.name || ''
    if (!n.includes('嘴角')) return false
    if (wantLeft) return n.includes('左') && !n.includes('右')
    return n.includes('右') && !n.includes('左')
  })
  if (candidates.length !== 2) return null
  const lo = candidates.find(s => (s.name || '').includes('下'))
  const hi = candidates.find(s => (s.name || '').includes('上'))
  if (lo && hi) return [lo.id, hi.id]
  return [...candidates].sort((a, b) => a.id - b.id).map(s => s.id)
}
